import * as React from 'react';
import BaseAnimation from './BaseAnimation';

const ModalAnimation = (props: $TSFixMe) => {
    const { children, opened, duration = 200 } = props;
    const style = {
        transitionProperty: 'opacity, margin',
        transitionDuration: `${duration}ms`,
        transitionTimingFunction: 'cubic-bezier(0.65, 0, 0.35, 1)',
        opacity: opened ? 1 : 0,
        marginTop: opened ? 0 : 10
    };

    return (
        <BaseAnimation {...props} active={opened} style={style} hideChildren={false}>
            {children}
        </BaseAnimation>
    );
};

export default ModalAnimation;
